import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ContactUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with actual submit logic (email service, API, etc.)
    alert('Thank you for contacting Totomart! We will get back to you soon.');
    setForm({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <Wrapper>
      <Header data-aos="fade-down">
        <h1>Contact Totomart</h1>
        <p>Have a question, suggestion, or business inquiry? We'd love to hear from you.</p>
      </Header>

      <Grid>
        <FormWrapper data-aos="fade-right">
          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} required />

            <label>Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} required />

            <label>Phone</label>
            <input type="tel" name="phone" value={form.phone} onChange={handleChange} required />

            <label>Message</label>
            <textarea name="message" rows="5" value={form.message} onChange={handleChange} required />

            <button type="submit">Send Message</button>
          </form>
        </FormWrapper>

        <InfoWrapper data-aos="fade-left">
          <h2>Our Office</h2>
          <p>
            Totomart (by Ligiotech Solutions Pvt Ltd) <br />
            No. 71, Appar Street, Thiruvalleswarar Nagar,<br />
            Thirumangalam, Anna Nagar,<br />
            Chennai, Tamil Nadu – 600040, India
          </p>

          <h2>Contact</h2>
          <p>Email: support@totomart.in</p>
          <p>Phone: +91-7373339225</p>
          <p>Business Hours: Mon–Sat, 10:00 am – 6:00 pm</p>
        </InfoWrapper>
      </Grid>
    </Wrapper>
  );
};

export default ContactUs;

// Styled-components
const Wrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 3rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    font-size: 2.4rem;
    color: #e53935;
  }

  p {
    font-size: 1rem;
    color: #555;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  min-width: 280px;

  form {
    display: flex;
    flex-direction: column;

    label {
      margin-top: 1rem;
      font-weight: 500;
    }

    input,
    textarea {
      padding: 0.8rem;
      margin-top: 0.4rem;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 1rem;
    }

    button {
      margin-top: 1.5rem;
      background: #e53935;
      color: white;
      border: none;
      padding: 0.9rem;
      border-radius: 5px;
      font-size: 1rem;
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #b71c1c;
      }
    }
  }
`;

const InfoWrapper = styled.div`
  flex: 1;
  min-width: 280px;

  h2 {
    color: #b71c1c;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 1rem;
    color: #444;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
`;
